<template>
  <div class="container">
    <Header
      :name="$t('app.profil.tabs.onboarding')"
    />
    <transition mode="out-in" name="fade">
      <div class="primary-container">
        <Onboarding></Onboarding>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import Header from "@/components/Header.vue";
import Onboarding from "./partials/Onboarding.vue";
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.container {
  margin: 0 auto;
  height: 100%;
  width: 1000px;

  .primary-container {
    height: 100%;
  
    .content-container {
      width: 100%;
  
      .card h3 {
        margin-bottom: 24px;
      }
  
      .informations-wrapper {
        width: 100%;
        position: relative;
        display: flex;
        flex: 1;
        overflow: auto;
  
        .container {
          position: relative;
          inset: 0;
          display: flex;
          gap: 24px;
          width: 100%;
  
          @media screen and (max-width: $small-screen) {
            flex-direction: column;
          }
  
          .card-form {
            width: 60%;
            gap: 32px;
  
            @media screen and (max-width: $small-screen) {
              width: 100%;
            }
  
            .form-container .btn {
              margin-left: auto;
            }
          }
  
          .side-col {
            position: sticky;
            height: fit-content;
            width: 40%;
            display: flex;
            flex-direction: column;
            gap: 32px;
  
            @media screen and (max-width: $small-screen) {
              width: 100%;
            }
  
            .header-block {
              display: flex;
              align-items: center;
              gap: 16px;
              margin-bottom: 24px;
  
              .picture {
                min-width: 72px;
                width: 72px;
                height: 72px;
                border: 2px solid $primary-color;
                border-radius: 100%;
                object-fit: cover;
              }
            }
  
            .delete-account p {
              margin-bottom: 8px;
            }
          }
  
          @media screen and (max-width: $small-screen) {
            .container {
              flex-direction: column;
  
              .card {
                width: 100%;
              }
            }
          }
        }
      }
  
      .links-container {
        display: flex;
        gap: 16px;
        padding-bottom: 32px;
        text-align: center;
        line-height: 18px;
  
        a {
          padding-bottom: 4px;
          
          &:nth-child(1) {
            padding-right: 16px;
            border-right: 1px solid var(--secondary-color);
          }
        }
      }
    }
  }
}


</style>
